import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectToken, selectUser } from "../../store/user/selectors";
import NavbarItem from "./NavbarItem";
import LoggedIn from "./LoggedIn";
import LoggedOut from "./LoggedOut";

export default function Navigation() {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);

  const loginLogoutControls = token ? <LoggedIn /> : <LoggedOut />;

  return (
    <Navbar style={{ background: "#eaebeb" }} expand="lg">
      <Navbar.Brand
        as={NavLink}
        to="/"
        style={{ fontFamily: "Source Code Pro, monospace" }}
      >
        &#60;Easy Coding&#62;
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav style={{ width: "100%" }} fill>
          <NavbarItem path="/posts" linkText="Posts" />
          <NavbarItem path="/requests" linkText="Requests" />
          {user.email ? (
            <NavbarItem path="/favourites" linkText="Favourites" />
          ) : null}
          {user.isAdmin ? (
            <NavbarItem path="/admin/manage-users" linkText="Manage Users" />
          ) : null}
          {loginLogoutControls}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
